import { toBool } from 'utils/string';

//
// The signed-in user's own preferences (GET/PUT settings/user, and the stored ones in the login answer's
// globalDataCache). The names are the API's UserSetting.Names; a missing row means the default below, which
// is the same default the API merges, so the two never disagree.
//
export const DarkMode = 'DarkMode';
export const NotificationsEmailApprovalRequested = 'NotificationsEmailApprovalRequested';
export const NotificationsEmailApprovalDecided = 'NotificationsEmailApprovalDecided';
export const NotificationsEmailScheduleIssues = 'NotificationsEmailScheduleIssues';
export const NotificationsEmailProposalReceived = 'NotificationsEmailProposalReceived';
export const NotificationsEmailProposalDecided = 'NotificationsEmailProposalDecided';

export const UserSettingNames: string[] = [
  DarkMode,
  NotificationsEmailApprovalRequested,
  NotificationsEmailApprovalDecided,
  NotificationsEmailScheduleIssues,
  NotificationsEmailProposalReceived,
  NotificationsEmailProposalDecided,
];

//every current setting holds a bool; dark mode is off by default, every notification family on
export function getUserSettingDefault(name: string): boolean {
  return name !== DarkMode;
}

export class UserSettings {
  items: UserSetting[];

  constructor() {
    this.items = [];
  }

  //the stored value when there is a row, otherwise the default
  get(name: string): boolean {
    const setting = this.items.find((s) => s.settingName === name);

    return setting ? setting.getValue() : getUserSettingDefault(name);
  }

  //whether the user has a stored row for this setting; the web seeds DarkMode once when there is none
  has(name: string): boolean {
    return this.items.some((s) => s.settingName === name);
  }

  set(name: string, value: boolean) {
    const setting = this.items.find((s) => s.settingName === name);
    if (setting) {
      setting.settingValue = value.toString();

      return;
    }

    const newSetting = new UserSetting();
    newSetting.settingName = name;
    newSetting.settingValue = value.toString();
    this.items.push(newSetting);
  }

  clone(): UserSettings {
    const newSettings = new UserSettings();
    newSettings.items = this.items.map((s) => s.clone());

    return newSettings;
  }
}

export default class UserSetting {
  settingName: string;

  settingValue: string | undefined;

  constructor() {
    this.settingName = '';
    this.settingValue = undefined;
  }

  getValue(): boolean {
    return toBool(this.settingValue);
  }

  clone(): UserSetting {
    const newSetting = new UserSetting();
    newSetting.settingName = this.settingName;
    newSetting.settingValue = this.settingValue;

    return newSetting;
  }
}
